/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import * as CircuitUtils from '../../../../utils/circuit';

export default class PositiveFeedback extends EmberObject {
  stageQ;
  gain;
  a;
  r3PlusR4;

  @computed('stageQ', 'a', 'gain') get q0() {
    var stageQ = this.stageQ;
    var gain = this.gain;
    var a = this.a;
    var result = 0;

    //According to Van Valkenburg textbook, this is close to an optimal at 1.5,
    //Paul Fleischer paper indicates something slightly higher might be better
    //Yet my experiments indicate higher numbers are better still for lowest tolerance issues.
    //Only reason I haven't set it higher is because the ratio between R1 and R2  gets to be really big.  Choosing 5 keeps the ratio at 100.
    var qHat = 5;

    if (a < 1) {
      result = qHat;
    } else {
      a = 0.9999999999;
      result = (-(a + gain) + Math.sqrt((a + gain) * (a + gain) - 8 * a * a * stageQ * stageQ)) / (-4 * a * stageQ);
    }

    return result;
  }

  @computed('q0', 'stageQ') get k() {
    var q0 = this.q0;
    var stageQ = this.stageQ;
    var alpha = (1 / (2 * q0 * q0)) * (1 - q0 / stageQ);
    var result = alpha / (1 + alpha);
    return result;
  }
  @computed('gain', 'q0', 'stageQ', 'k') get h() {
    var gain = this.gain;
    var q0 = this.q0;
    var stageQ = this.stageQ;
    var k = this.k;
    var result = gain * (q0 / stageQ) * (1 - k);
    return result;
  }

  @computed('k', 'r3PlusR4') get r3AndR4() {
    var k = this.k;
    var r3PlusR4 = this.r3PlusR4;
    var result = CircuitUtils.computeR3AndR4(r3PlusR4, 1 / k);
    return result;
  }
  @computed('r3AndR4.r3') get r3Value() {
    var result = this.r3AndR4.r3;
    return result;
  }

  @computed('r3AndR4.r4') get r4Value() {
    var result = this.r3AndR4.r4;
    return result;
  }

  @computed('h', 'q0') get b() {
    return this.h / 2 / (this.q0 * this.q0);
  }
}
